import React, {Fragment, useEffect, useState} from "react";
import {fetchPlaces} from "../../redux/actions/";
import {PlaceCard} from "./PlaceCard";
import {Header, Loader, Segment} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";

export const Places = ({from, search, setMarkers, setPagination, location, category}) => {

    const [places, setPlaces] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // const values = queryString.parse(location.search);
    const main = 1;

    useEffect(() => {

        const fetchData = async () => {

            // start loading
            setIsLoading(true);

            if (from === 'search') {

                from = 'places';
            }

            try {

                window.scrollTo(0, 0);

                // get places
                const result = await fetchPlaces({from, main, ...search});

                // set places
                setPlaces(result.data.data);
                setMarkers(result.data.data);

                setPagination(result.data.pagination);

            } catch (e) {

                // show errors
                console.log('error', e);
            }

            // stop loading
            setIsLoading(false);
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [from, search]);

    if (!isLoading && places.length === 0) {

        return (
            <Segment textAlign={"center"} style={{width: '100%'}}>
                <Header>
                    <FormattedMessage id="Nenhum resultado encontrado"/>
                </Header>
            </Segment>
        );
    }

    return (
        <Fragment>
            {
                isLoading
                    ? <Loader active inline/>
                    : places.map((place) => {

                        return (
                            <PlaceCard
                                key={`place-list-${place.id}`}
                                from={from}
                                place={place}
                                category={category}
                            />
                        );
                    })
            }
        </Fragment>
    );
};
